/**
 * 支持的方法列表及说明，所有方法的参数与原生插件完全一致：
 *
 * 【基础服务管理】
 * connectService - 连接 TMS 服务，必须先调用，参数：`{}`
 * disconnectService - 断开 TMS 服务，参数：`{}`
 *
 * 【设备信息模块】
 * getSerialNo - 获取设备序列号，参数：`{}`
 * getManufacture - 获取设备厂商，返回Sunmi，参数：`{}`
 * getModel - 获取Sunmi设备型号，参数：`{}`
 * getAndroidOSVersion - 获取Android版本，参数：`{}`
 * getMac - 获取MAC地址，参数：`{}`
 * getSDKVersion - 获取SDK版本，参数：`{}`
 * getIMEIBySlotIndex - 根据卡槽索引获取IMEI，参数：`{ slotIndex: 0 }`
 * getAndroidKernelVersion - 获取内核版本，参数：`{}`
 * getROMVersion - 获取ROM版本，参数：`{}`
 * getFirmwareVersion - 获取固件版本，参数：`{}`
 * getHardwareVersion - 获取硬件版本，参数：`{}`
 * getMemoryOccupation - 获取已用内存(字节)，参数：`{}`
 * getSystemProperty - 获取系统属性值，参数：`{ key: "" }`
 * getIMSIBySlotIndex - 根据卡槽索引获取IMSI，参数：`{ slotIndex: 0 }`
 * getFullICCID - 获取ICCID，参数：`{ slotIndex: 0 }`
 * getSunmiOsVersion - 获取Sunmi OS版本，参数：`{}`
 * getIpAddresses - 获取IP列表(逗号分隔)，参数：`{}`
 * getDeviceBluetoothMacAddress - 获取蓝牙MAC，参数：`{}`
 * isFinancialDevice - 是否是金融设备，返回"true"/"false"，参数：`{}`
 * verifyCrp - 校验资源包，参数：`{ filePath }`
 * installCrp - 安装资源包，参数：`{ filePath }`
 * getCrpType - 获取资源包类型，参数：`{ filePath }`
 * getCrpVersion - 获取资源包版本，参数：`{ crpType }`
 * getGmsFlag - 获取GMS标志，参数：`{}`
 * isInnerScannerSupported - 是否支持内置扫码器，参数：`{}`
 * isInnerPrinterSupported - 是否支持内置打印机，参数：`{}`
 * getSystemBuildDisplayId - 获取Build显示ID，参数：`{}`
 * getIMSI - 获取默认卡IMSI，参数：`{}`
 * getIMEI - 获取默认卡IMEI，参数：`{}`
 * getBrand - 获取设备品牌，参数：`{}`
 *
 * 【设备管理模块】
 * powerReboot - 重启设备，参数：`{}`
 * shutdown - 关机，参数：`{}`
 * factoryReset - 恢复出厂设置，参数：`{}`
 * setScreenBrightness - 设置屏幕亮度，参数：`{ brightness: 128 }`（取值0~255）
 * setScreenTimeout - 设置屏幕超时，参数：`{ timeout: 60000 }`（单位毫秒）
 * getScreenBrightness - 获取屏幕亮度值，参数：`{}`
 * enableWIFI - WiFi开关，参数：`{ enable: true }`
 * enableBluetooth - 蓝牙开关，参数：`{ enable: true }`
 * enableLocation - 定位开关，参数：`{ enable: true }`
 * setSystemTime - 设置系统时间，参数：`{ second, minute, hour, day, month, year }`
 * setTimeZone - 设置时区，参数：`{ timeZone: "GMT+08:00" }`
 * toSleep - 休眠设备，参数：`{}`
 * toWakeUp - 唤醒设备，参数：`{}`
 * setBootAnimation - 设置开机动画，参数：`{ filePath }`
 * setCustomKeyFunction - 自定义按键功能，参数：`{ key, type, value }`
 * setPowerButtonEnabled - 设置电源键可用性，参数：`{ enabled }`
 * isPowerButtonEnabled - 获取电源键状态，参数：`{}`
 * setWallpaper - 设置壁纸，参数：`{ filePath }`
 * setBrightnessMode - 设置亮度模式，参数：`{ mode }`
 * getMinimumScreenBrightnessSetting - 获取最小亮度设置，参数：`{}`
 * getMaximumScreenBrightnessSetting - 获取最大亮度设置，参数：`{}`
 * setDeviceOwner - 设置设备所有者，参数：`{ packageName, classFullPathName }`
 * clearDeviceOwner - 清除设备所有者，参数：`{}`
 * switchBTModuleEnable - 蓝牙模块开关，参数：`{ enable }`
 * isBTModuleEnabled - 获取蓝牙模块状态，参数：`{}`
 * enableAutoTime - 自动时间开关，参数：`{ enable: true }`
 * enableAutoTimeZone - 自动时区开关，参数：`{ enable: true }`
 * set24Hour - 设置24小时制，参数：`{ is24Hour }`
 * setAirplaneMode - 设置飞行模式，参数：`{ open }`
 * setPhysicKeyEnabled - 物理键开关，参数：`{ type, enable }`
 * getPhysicKeyEnabled - 获取物理键状态，参数：`{ type }`
 * enableGPS - GPS开关，参数：`{ isEnable }`
 * enableNFC - NFC开关，参数：`{ enable }`
 *
 * 【软件管理模块】
 * installAppV2 - 安装APK（有回调），参数：`{ apkPath, autoStart }`
 * uninstallApp - 卸载应用，参数：`{ packageName }`
 * killApp - 强制停止应用，参数：`{ packageName }`
 * setAppEnabled - 禁用/启用应用，参数：`{ packageName, enabled }`
 * restartApp - 重启应用，参数：`{ packageName }`
 * setBatteryOptimizationWhitelist - 设置电池优化白名单，参数：`{ whitelist }`
 * grantAppPermissions - 授予应用权限，参数：`{ packageName, permissions }`
 * getRequestPermissions - 获取权限列表，参数：`{ packageName }`
 * allowAlertWindowPermission - 授予悬浮窗权限，参数：`{ packageName }`
 * prohibitUninstall - 禁止/允许卸载应用，参数：`{ packageName, allowUninstall }`
 * getProhibitUninstallList - 获取禁止卸载列表，参数：`{}`
 * enableAutoStartApp - 自启动功能开关，参数：`{ enable: true }`
 * isAutoStartAppEnabled - 获取自启动功能状态，参数：`{}`
 * setAutoStartApp - 设置自启动应用，参数：`{ packageName }`
 * getAutoStartApp - 获取自启动应用，参数：`{}`
 * clearAutoStartApp - 清空自启动应用，参数：`{}`
 * isForeground - 应用是否在前台，参数：`{ packageName }`
 * addAppToCommonAppLockList - 添加到应用锁，参数：`{ packageNames, type, password }`
 * removeAppFromCommonAppLockList - 从应用锁移除，参数：`{ packageNames }`
 * getCommonAppLockList - 获取应用锁列表，参数：`{}`
 * isCommonAppLock - 应用是否在应用锁中，参数：`{ packageName }`
 * installApp - 安装APK（无回调），参数：`{ apkPath }`
 * revokeAppPermission - 撤销应用权限，参数：`{ packageName, permissions }`
 * setNotificationsEnabledForPackage - 通知开关，参数：`{ packageName, enabled }`
 * clearApplicationUserDataWithResult - 清除应用用户数据，异步回调返回结果，参数：`{ packageName }`
 * deleteApplicationCacheFiles - 删除应用缓存数据，异步回调返回结果，参数：`{ packageName }`
 *
 * 【系统管理模块】
 * updateSystem - 系统升级，参数：`{ systemPath }`
 * setDefaultLauncher - 设置默认桌面，参数：`{ packageName }`
 * setSystemLanguage - 设置系统语言，参数：`{ language: "zh-CN" }`
 * enableAdbWithResult - ADB开关，参数：`{ enable }`
 * doScreenshot - 截图，返回fd，参数：`{}`
 * enableCommonAppLock - 应用锁全局开关，参数：`{ enable }`
 * isCommonAppLockEnabled - 获取应用锁状态，参数：`{}`
 * disableSecurityPCI24HoursReboot - PCI重启开关，参数：`{ disable }`
 * set24HourRebootRegular - 定时重启，参数：`{ type, hour, minute, second }`
 * setSecurityCenterPwd - 设置安全中心密码，参数：`{ password }`
 * isAdbEnabled - 获取ADB状态，参数：`{}`
 * getSystemPackageList - 获取系统包名列表，参数：`{}`
 *
 * 【系统UI管理模块】
 * showNatigationBar - 导航栏显隐（保留官方原始拼写），参数：`{ show }`
 * showStatusBar - 状态栏显隐，参数：`{ show }`
 * showNavigationBarBackButton - 返回键显隐，参数：`{ show }`
 * showNavigationBarHomeButton - Home键显隐，参数：`{ show }`
 * showNavigationBarRecentsButton - 多任务键显隐，参数：`{ show }`
 * enableNotificationPanel - 通知栏下拉开关，参数：`{ enable }`
 * enableNavigationBarBackButton - 返回键可用性，参数：`{ enable }`
 * isNavigationBarBackButtonEnabled - 获取返回键状态，参数：`{}`
 * enableNavigationBarHomeButton - Home键可用性，参数：`{ enable }`
 * isNavigationBarHomeButtonEnabled - 获取Home键状态，参数：`{}`
 * enableNavigationBarRecentsButton - 多任务键可用性，参数：`{ enable }`
 * isNavigationBarRecentsButtonEnabled - 获取多任务键状态，参数：`{}`
 * setAirplaneModeBarClickable - 快捷栏飞行模式可点击，参数：`{ clickable }`
 *
 * 【设备运行时信息模块】
 * getBatteryCapacity - 获取电池容量，参数：`{}`
 * getCpuUsage - 获取CPU使用率，参数：`{}`
 * getRamTotalSize - 获取总内存(字节)，参数：`{}`
 * getRamUsedSize - 获取已用内存(字节)，参数：`{}`
 * getRomTotalSize - 获取总存储(字节)，参数：`{}`
 * getRomUsedSize - 获取已用存储(字节)，参数：`{}`
 * getGPSLocation - 获取GPS位置信息，参数：`{}`
 * getTurnOnMills - 获取开机时长(毫秒)，参数：`{}`
 * getGPSLocationWithTimeout - 实时获取GPS位置，支持超时，参数：`{ timeout: 10000 }`
 *
 * 【网络管理模块】
 * enableMobileNetwork - 卡槽移动数据开关，参数：`{ slotIdx, enable }`
 * getDefaultDataSlotIndex - 获取默认数据卡槽，参数：`{}`
 * setDefaultDataSlotIndex - 设置默认数据卡槽，参数：`{ slotIndex }`
 * getMobileDataStatusBySlot - 获取卡槽数据状态，参数：`{ slotIndex }`
 * setMobileDataLocked - 锁定移动数据开关，参数：`{ locked }`
 * getDataRoamingEnabled - 获取数据漫游状态，参数：`{ slotIndex }`
 * setDataRoamingEnabled - 设置数据漫游开关，参数：`{ slotIndex, enable }`
 * setCustomNtpServer - 设置NTP服务器，参数：`{ server }`
 * getCustomNtpServer - 获取NTP服务器，参数：`{}`
 * forgetSavedWifi - 遗忘所有WiFi，参数：`{}`
 * resetNetworkSettings - 重置网络设置，参数：`{}`
 * installWlanCertificate - 安装WiFi证书，参数：`{ name, certData, password }`
 * turnOffWifiHotspot - 关闭热点，参数：`{}`
 * turnOnWifiHotspot - 开启热点，参数：`{ ssid, preShareKey, keyManagement }`
 * isWifiHotspotEnable - 获取热点状态，参数：`{}`
 * showWifiHotspotSettings - 跳转热点设置，参数：`{}`
 * disableWifiHotspotAndHideSettings - 禁用热点并隐藏设置，参数：`{}`
 * enableEthernet - 以太网开关，参数：`{ enable }`
 * queryTrafficUsageSummary - 流量统计，参数：`{ networkType, startTime, endTime }`
 * addNetwork - 添加WiFi配置，参数：`{ ssid, preSharedKey }`
 * updateNetwork - 更新WiFi配置，参数：`{ networkId, ssid, preSharedKey }`
 * removeNetwork - 删除WiFi配置，参数：`{ networkId }`
 * getConfiguredNetworks - 获取已保存WiFi列表，参数：`{}`
 * isActiveSlotIndex - SIM卡是否可用，参数：`{ slotIndex }`
 * getMobileDataStatus - 获取移动数据总开关，参数：`{}`
 * getTrafficOfEachApp - 获取每个应用的流量统计，参数：`{ networkType, startTime, endTime }`
 * setWifiStaticIpV2 - 设置/禁用静态IP，异步回调，参数：`{ status, ipAddr, gateway, networkPrefixLength, dns1, dns2, reconnect }`
 * connectWifiSsid - 连接已保存的WiFi，通过SSID，参数：`{ ssid }`
 * removeWifiSsid - 移除已保存的WiFi，通过SSID，参数：`{ ssid }`
 * addWifiSsidByWifiConfiguration - 通过配置对象添加WiFi，参数：`{ wifiConfig: { ssid, preSharedKey, securityType } }`
 *
 * 【设备软件信息模块】
 * getSystemAllPackageInfo - 获取系统应用信息JSON字符串，参数：`{}`
 *
 * 【霸屏管理模块】
 * enableKioskFunction - 打开/关闭整个霸屏功能，参数：`{ enable: true }`
 * isKioskFunctionEnabled - 获取霸屏功能的整体可用状态，参数：`{}`
 * getKioskModeStatus - 获取当前是否处于霸屏模式，参数：`{}`
 * addAppToKioskList - 将多个应用包名添加到霸屏白名单，参数：`{ packageNames: "com.a,com.b" }`
 * removeAppFromKioskList - 从霸屏白名单中移除指定应用，参数：`{ packageNames: "com.a" }`
 * getKioskAppList - 获取当前霸屏白名单中的应用列表，参数：`{}`
 * isKioskApp - 查询某个应用是否在霸屏白名单中，参数：`{ packageName: "com.xx" }`
 * setKioskPwdByType - 设置退出霸屏时需要输入的密码，参数：`{ type: 1, password: "1234" }`
 * setNavigationBarStatusForKiosk - 设置霸屏模式下导航栏的显示模式，参数：`{ status: 1 }`
 * getNavigationBarStatusForKiosk - 获取霸屏模式下导航栏的显示模式，参数：`{}`
 * hideStatusBarForKiosk - 霸屏模式下是否隐藏状态栏，参数：`{ hide: true }`
 * isStatusBarHiddenForKiosk - 获取霸屏模式下状态栏是否隐藏，参数：`{}`
 * switchKioskPwdByType - 设置退出霸屏时需要的密码类型，参数：`{ type: 2 }`
 * getSwitchKioskPwdByType - 获取退出霸屏时需要的密码类型，参数：`{}`
 * exitKioskMode - 直接退出霸屏模式，参数：`{ password: "1234" }`
 *
 * 【证书管理模块】
 * updateCertificate - 更新应用验签证书，参数：`{ certPath: "/sdcard/cert.cer" }`
 * getCertificateInfo - 获取当前应用验签证书信息，参数：`{}`
 * getTrustedFileCertChain - 获取应用验签可信证书链信息，参数：`{}`
 *
 * 【商米打印模块】
 * initPrinter - 初始化打印机，参数：`{}`
 * printText - 打印文本内容，参数格式参考注释
 *
 * 【芯烨打印模块】
 * initUsb - 初始化USB打印机，参数：`{}`
 * connectUsbPrinter - 连接USB打印机，参数：`deviceName`
 * printText - 打印文本内容，参数格式参考注释
 */

// 日志开关
const DEBUG = true;
const log = (...args) => DEBUG && console.log('[Native-Plugin]', ...args);
const errorLog = (...args) => DEBUG && console.error('[Native-Plugin]', ...args);

const SDK_STATUS = { IDLE: 'idle', INITIALIZING: 'initializing', SUCCESS: 'success', FAIL: 'fail' };

// SDK初始化器
const sdkInitializers = {
    sunmi: async () => {
        log('开始初始化商米SDK');
        if (!uni?.requireNativePlugin) throw new Error('环境不支持，请在App端运行');
        const instance = uni.requireNativePlugin('uni-sunmi-plugin');
        if (!instance) throw new Error('未找到商米插件');

        return new Promise((resolve, reject) => {
            instance.connectService(
                {},
                (res) => {
                    if (res?.code == 0) {
                        log('商米SDK TMS服务连接成功');
                        resolve(instance);
                    } else {
                        reject(new Error(`TMS服务连接失败: ${res?.msg}`));
                    }
                },
                (err) => reject(err)
            );
        });
    },
    xinYe: async () => {
        log('开始初始化芯烨SDK');
        if (!uni?.requireNativePlugin) throw new Error('环境不支持');
        const instance = uni.requireNativePlugin('xinye-print');
        if (!instance) throw new Error('未找到芯烨插件');
        log('芯烨SDK初始化完成');
        return instance;
    },
    voice: async () => {
        log('开始初始化讯飞SDK');
        if (!uni?.requireNativePlugin) throw new Error('环境不支持');
        const instance = uni.requireNativePlugin('xunfei-voice');
        if (!instance) throw new Error('未找到讯飞插件');
        instance.initSdk((e) => {
            log(`讯飞SDK初始化完成${JSON.stringify(e)}`);
        });
        return instance;
    }
};

const state = {
    initPromise: null,
    manualInit: false,
    sdkInstances: {},
    sdkStatus: {}
};

async function initSingleSdk(sdkKey) {
    const initializer = sdkInitializers[sdkKey];
    if (!initializer || state.sdkStatus[sdkKey] === SDK_STATUS.SUCCESS || state.sdkStatus[sdkKey] === SDK_STATUS.INITIALIZING) return;

    state.sdkStatus[sdkKey] = SDK_STATUS.INITIALIZING;
    try {
        const instance = await initializer();
        state.sdkInstances[sdkKey] = instance;
        state.sdkStatus[sdkKey] = SDK_STATUS.SUCCESS;
    } catch (e) {
        state.sdkStatus[sdkKey] = SDK_STATUS.FAIL;
        errorLog(`SDK [${sdkKey}] 初始化失败`, e);
        throw e;
    }
}

async function init(sdks = []) {
    state.manualInit = true;
    state.initPromise = new Promise(async (resolve) => {
        for (const key in state.sdkInstances) {
            try {
                state.sdkInstances[key].disconnectService?.({});
            } catch (e) {
                console.log(e);
            }
        }
        state.sdkInstances = {};
        state.sdkStatus = {};

        if (!sdks.length) return resolve(false);
        try {
            await Promise.allSettled(sdks.map(initSingleSdk));
            resolve(Object.values(state.sdkStatus).includes(SDK_STATUS.SUCCESS));
        } catch (e) {
            resolve(false);
        }
    });
    return state.initPromise;
}

async function autoInit() {
    if (state.manualInit) return;
    state.initPromise = new Promise((resolve) => {
        if (!uni?.getSystemInfo) return resolve(false);
        uni.getSystemInfo({
            success: (res) => {
                if (res.deviceBrand?.toLowerCase() === 'sunmi' && res.uniPlatform === 'app') {
                    initSingleSdk('sunmi').finally(() => resolve(state.sdkStatus.sunmi === SDK_STATUS.SUCCESS));
                } else {
                    resolve(false);
                }
            },
            fail: () => resolve(false)
        });
    });
    return state.initPromise;
}

function getSdkStatus(sdkKey) {
    return state.sdkStatus[sdkKey] || SDK_STATUS.IDLE;
}
function hasAvailableSdk() {
    return Object.values(state.sdkStatus).includes(SDK_STATUS.SUCCESS);
}

/**
 * 统一的原生方法执行器（支持透传参数 + 兼容 Promise 封装）
 */
function executeNativeMethod(instance, methodName, originalArgs, sdkName = '原生') {
    return new Promise((resolve, reject) => {
        const fireFail = (errObj) => {
            const cbs = originalArgs.filter((arg) => typeof arg === 'function');
            if (cbs.length >= 2) cbs[1](errObj);
            else if (cbs.length === 1) cbs[0](errObj);
            reject(errObj);
        };

        if (typeof instance[methodName] !== 'function') {
            return fireFail({ code: -1, msg: `${sdkName}SDK 不支持或无此方法 [${methodName}]` });
        }

        try {
            const finalArgs = [...originalArgs];
            const functionIndices = [];

            // 找出所有传进来的回调函数
            finalArgs.forEach((arg, idx) => {
                if (typeof arg === 'function') functionIndices.push(idx);
            });

            if (functionIndices.length > 0) {
                const successIdx = functionIndices[0];
                const origSuccess = finalArgs[successIdx];
                finalArgs[successIdx] = (res) => {
                    if (origSuccess) origSuccess(res);
                    resolve(res);
                };

                if (functionIndices.length > 1) {
                    const failIdx = functionIndices[1];
                    const origFail = finalArgs[failIdx];
                    finalArgs[failIdx] = (err) => {
                        if (origFail) origFail(err);
                        reject(err);
                    };
                }
            } else {
                // Uniapp 原生端方法通常必须带 UniJSCallback 才能匹配签名。
                finalArgs.push((res) => {
                    resolve(res);
                });
            }

            log(`执行${sdkName}方法 [${methodName}], 最终参数:`, finalArgs);
            instance[methodName](...finalArgs);
        } catch (e) {
            const err = { code: -1, msg: `${sdkName}方法 [${methodName}] 崩溃: ${e.message}`, error: e };
            errorLog(err.msg);
            fireFail(err);
        }
    });
}

// 核心分发处理器
async function handleMethodCall(methodName, args) {
    await state.initPromise;
    if (!hasAvailableSdk()) {
        const err = { code: -1, msg: '无可用的SDK实例或初始化失败' };
        errorLog(err.msg);
        const failCb = args.find((a) => typeof a === 'function');
        if (failCb) failCb(err);
        return Promise.reject(err);
    }

    // 商米及通用方法：遍历寻找并执行
    for (const sdkKey in state.sdkInstances) {
        if (state.sdkStatus[sdkKey] === SDK_STATUS.SUCCESS && typeof state.sdkInstances[sdkKey][methodName] === 'function') {
            return executeNativeMethod(state.sdkInstances[sdkKey], methodName, args, '商米通用');
        }
    }

    const err = { code: -1, msg: `所有成功初始化的SDK中均未找到方法 [${methodName}]` };
    errorLog(err.msg);
    return Promise.reject(err);
}

const IS_INTERNAL_PROP = (prop) => {
    return (
        typeof prop === 'symbol' ||
        prop === 'prototype' ||
        prop.startsWith('__v_') ||
        prop.startsWith('$') ||
        ['then', 'catch', 'finally', 'toJSON', 'toString', 'valueOf', 'constructor', 'name', 'length', 'call', 'apply', 'bind'].includes(prop)
    );
};

const nativePlugin = new Proxy(
    {},
    {
        get: (target, prop) => {
            if (prop === 'init') return init;
            if (prop === 'autoInit') return autoInit;
            if (prop === 'getSdkStatus') return getSdkStatus;
            if (prop === 'hasAvailableSdk') return hasAvailableSdk;

            // 屏蔽内置属性干扰
            if (IS_INTERNAL_PROP(prop)) return Reflect.get(target, prop);

            // 芯烨SDK独立模块处理
            if (prop === 'xinYe') {
                return new Proxy(
                    {},
                    {
                        get: (_, xinYeProp) => {
                            if (IS_INTERNAL_PROP(xinYeProp)) return Reflect.get(target, xinYeProp);

                            return async (...args) => {
                                await initSingleSdk('xinYe');
                                if (state.sdkStatus.xinYe !== SDK_STATUS.SUCCESS) {
                                    const msg = '芯烨SDK不可用，请确认环境';
                                    errorLog(msg);
                                    return Promise.reject({ code: -1, msg });
                                }
                                return executeNativeMethod(state.sdkInstances.xinYe, xinYeProp, args, '芯烨');
                            };
                        }
                    }
                );
            }
            if (prop === 'voice') {
                return new Proxy(
                    {},
                    {
                        get: (_, xinYeProp) => {
                            if (IS_INTERNAL_PROP(xinYeProp)) return Reflect.get(target, xinYeProp);

                            return async (...args) => {
                                await initSingleSdk('voice');
                                if (state.sdkStatus.voice !== SDK_STATUS.SUCCESS) {
                                    const msg = '讯飞SDK不可用，请确认环境';
                                    errorLog(msg);
                                    return Promise.reject({ code: -1, msg });
                                }
                                return executeNativeMethod(state.sdkInstances.voice, xinYeProp, args, '芯烨');
                            };
                        }
                    }
                );
            }

            // 拦截任意方法，透传给原生处理
            return (...args) => handleMethodCall(prop, args);
        }
    }
);

// 加载时自动初始化
autoInit();

export default nativePlugin;

//调用demo
// 1. 导入封装好的插件
// import nativePlugin from '@/utils/nativePlugin.js'
// 如需手动初始化多个SDK，优先级高于自动检测
//  nativePlugin.init(['sunmi', 'xinYe'])

// ------------------- 商米内置打印机调用demo -------------------
// const printList=ref([])
// // 2. 直接调用方法，和原生SDK的调用方式完全一样
// onMounted(()=>{
// printOrder()
//})
// const printOrder=async()=> {
//   try {
//     // 初始化打印机，会自动等待商米的TMS服务连接成功
//     nativePlugin.initPrinter({}, (res) => {
//       if (res.code === 0) {
//         // 打印文本，同样会自动等待初始化完成
//
//       }
//     })
//   } catch (e) {
//     // 错误处理：如果商米SDK初始化失败，会自动走到这里
//     console.error('打印失败', e)
//     uni.showToast({ title: '打印失败，请检查设备', icon: 'none' })
//   }
// }
//      使用的地方里面调用这个打印
//      nativePlugin.printText({
//     titleInfo: {
//         title: '顾客小票',
//         size: 20
//     },
//     printerId: lists.value[1],
//     data: [
//         {
//             type: 'text',
//             content: '这是一段开始文本\n\n\n\n',
//             flex: '1',
//             size: 16,
//             align: 'CENTER',
//             bold: true
//         },
//         {
//             type: 'table',
//             tableTitles: [
//                 {
//                     content: '商品名',
//                     flex: '1',
//                     size: 32,
//                     align: 'LEFT',
//                     bold: true,
//                     width: 15
//                 },
//                 {
//                     content: '规格',
//                     flex: '1',
//                     size: 32,
//                     align: 'LEFT',
//                     bold: true,
//                     width: 10
//                 },
//                 {
//                     content: '价格',
//                     flex: '1',
//                     size: 32,
//                     align: 'LEFT',
//                     bold: true,
//                     width: 15
//                 }
//             ],
//             tableRows: [
//                 {
//                     content: '奶茶'
//                 },
//                 {
//                     content: '热'
//                 },
//                 {
//                     content: '5.00'
//                 },
//                 {
//                     content: '可乐'
//                 },
//                 {
//                     content: '冷'
//                 },
//                 {
//                     content: '10.00'
//                 }
//             ]
//         },
//         {
//             type: 'text',
//             content: '这是一段结束文本\n\n\n\n',
//             flex: '1',
//             size: 16,
//             align: 'CENTER',
//             bold: true
//         }
//     ]
// }, (printRes) => {
//           console.log('打印结果', printRes)
//         })
//  调用其他方法
// async function getDeviceInfo() {
//   try {
//     // 获取设备序列号，自动等待TMS服务连接完成
//     nativePlugin.getSerialNo({}, (res) => {
//       if (res.code === 0) {
//         console.log('设备序列号：', res.data)
//       }
//     })

//     // 设置屏幕亮度，参数和原生SDK完全一致
//     nativePlugin.setScreenBrightness({ brightness: 200 }, (res) => {
//       console.log('亮度设置结果', res)
//     })
//   } catch (e) {
//     console.error('操作失败', e)
//   }
// }

// ------------------- 芯烨外接打印机调用demo -------------------
// const printOrderXinYe = async () => {
//   try {
//     // 初始化USB打印机，会自动初始化芯烨SDK
//     nativePlugin.xinYe.initUsb((res) => {
//       console.log('芯烨初始化', res);
//       if (res.code == 0 && res?.data?.length > 0) {
//         // 测试连接第一个打印机
//         nativePlugin.xinYe.connectUsbPrinter(res?.data[0]?.deviceName, (data) => {
//           console.log('链接打印机', data);
//           if (data.code == 0) {
//             // 打印小票
//             nativePlugin.xinYe.printText(
//               {
//                 titleInfo: {
//                   title: '顾客小票',
//                   size: 20
//                 },
//                 printerId: lists.value[1],
//                 data: [
//                   {
//                     type: 'text',
//                     content: '这是一段开始文本\n\n\n\n',
//                     flex: '1',
//                     size: 16,
//                     align: 'CENTER',
//                     bold: true
//                   },
//                   {
//                     type: 'table',
//                     tableTitles: [
//                       {
//                         content: '商品名',
//                         flex: '1',
//                         size: 32,
//                         align: 'LEFT',
//                         bold: true,
//                         width: 15
//                       },
//                       {
//                         content: '规格',
//                         flex: '1',
//                         size: 32,
//                         align: 'LEFT',
//                         bold: true,
//                         width: 10
//                       },
//                       {
//                         content: '价格',
//                         flex: '1',
//                         size: 32,
//                         align: 'LEFT',
//                         bold: true,
//                         width: 15
//                       }
//                     ],
//                     tableRows: [
//                       {
//                         content: '奶茶'
//                       },
//                       {
//                         content: '热'
//                       },
//                       {
//                         content: '5.00'
//                       },
//                       {
//                         content: '可乐'
//                       },
//                       {
//                         content: '冷'
//                       },
//                       {
//                         content: '10.00'
//                       }
//                     ]
//                   },
//                   {
//                     type: 'text',
//                     content: '这是一段结束文本\n\n\n\n',
//                     flex: '1',
//                     size: 16,
//                     align: 'CENTER',
//                     bold: true
//                   }
//                 ]
//               },
//               (res) => {
//                 console.log('-打印成功没得', res);
//               }
//             );
//           }
//         });
//       }
//     });
//   } catch (e) {
//     console.error('芯烨打印失败', e)
//     uni.showToast({ title: '打印失败，请检查芯烨打印机连接', icon: 'none' })
//   }
// }
